
const initialState = {
    employer_holiday: [],
    error: null,
    isLoding: false
  };

const CompanyHolidayApiReducer = (state = initialState, action) => {
    switch (action.type) {
      case "LODING":
        return {
          ...state,
          isLoding: action.payload
        };
  
      case "GET_HOLIDAYS_SUCCESS":
        return {
          ...state,
          employer_holiday: action.payload,
          error: null
        };
      case "GET_HOLIDAYS_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };

      case "ADD_HOLIDAY_SUCCESS":
          return{
            ...state,
            error: null
            
      
      };
        
      case "ADD_HOLIDAY_FAILURE":
          return{
            ...state,
            error: action.payload.error
          
      };
    
  
     
      default:
        return state;
    }
  };
  
  export default CompanyHolidayApiReducer;
  
